var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('monitored-detail',{attrs:{"fields":[
      { key: 'id', label: 'id', },
      { key: 'client_id', label: 'Estabelecimento'},
      { key: 'monitoring_client_type_id', label: 'tipo' },
      { key: 'message', label: 'Mensagem' },
      { key: 'created_at', label: 'Criado Em' } ],"items":_vm.itemsReversed}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }